module.exports = __webpack_public_path__ + "static/img/weizhongjiang.2a6a2a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zjd_img/weizhongjiang.png
// module id = r9E7
// module chunks = 36